import { render, staticRenderFns } from "./fileBox.vue?vue&type=template&id=7000a42c&scoped=true&"
import script from "./fileBox.vue?vue&type=script&lang=js&"
export * from "./fileBox.vue?vue&type=script&lang=js&"
import style0 from "./fileBox.vue?vue&type=style&index=0&id=7000a42c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7000a42c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VImg,VRow,VSpacer})
